import { cn } from '@repo/ui/lib/utils'
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react'

interface Props {
  title: ReactNode
  className?: string
}

const ProductStickySection: FunctionComponent<PropsWithChildren<Props>> = ({ title, children, className }) => {
  return (
    <section
      className={cn(
        'bg-(--color-background) top-(--spacing-miista-content-offset-dynamic-tight) flex flex-col overflow-clip transition-[top] duration-200 ease-out [@media(min-height:55rem)]:sticky',
        className,
      )}
    >
      <h2 className='p-miista-page-padding ml-miista-button-padding-x-default uppercase'>{title}</h2>
      {children}
    </section>
  )
}

export default ProductStickySection
